export default {
    pcd: "23",
    pname: "愛知県",
    header: "【愛知県】Go To Eatキャンペーン 食事券 第2期 抽選 Web 受付",
    explanation: "本サイトは、【愛知県】GoToEatキャンペーン食事券第2期抽選 Web 受付サイトです。\n【愛知県】GoToEatキャンペーン食事券の抽選 Web 受付応募方法をご案内します。\n以下同意したうえでメールアドレスのご登録をお願いいたします。",
    emailreceptionsettings: "@funity-rs.jp より、メールを配信いたしますので受信可能に設定してください。\nメールが受信できない場合、お客様の端末にて迷惑メール対策設定が行われている可能性がございます。\n以下の設定方法をご確認頂き、「@funity-rs.jp」からメールを受信出来るように設定をお願い致します。",
    personalinfo: "ご入力いただきました個人情報は、【愛知県】GoToEatキャンペーン食事券の販売のために使用いたします。\n個人情報は、法令に基づく場合を除き、ご本人様の承諾なしに第三者（弊社業務委託先を除く）に提供することはありません。",
    salesdatailstitles: {
        term: "応募受付期間",
        limitation: "応募申込可能数",
        winningannouncement: "当選通知配信日"
    },
    winningannouncement: "未定 ※決定次第順次配信を開始",
    emailhints: [
        "※メールアドレスに間違いがないか必ずご確認ください。",
        "※「@funity-rs.jp」からメールを受信出来るように設定をお願いします。"
    ],
    emailsendbtn: "応募申込用URL送信",
    sentmsg: {
        header: "メールアドレスのご登録",
        body: {
            lines: [
                "ご登録されたメールアドレスに、応募申込URLを送信しました。",
                "現時点では応募申込は完了しておりません。",
                "ご案内メールの応募申込URLより応募申込手続きを行ってください。",
                "いかなる場合でも、メールの再送はできません。\n※メールを削除または紛失した場合は、再度抽選Web受付サイトにてメールアドレスの登録手続きを行ってください。"
            ]
        },
        mailnotice: {
            header: "メールが届かない場合は以下をご確認ください。",
            items:[
               "迷惑メールボックスやごみ箱フォルダに入っていないかご確認ください。",
               "上記をご確認いただき、申込完了通知が届いていない場合は、「@funity-rs.jp」からメールを受信出来るように設定のうえ、再度抽選Web受付サイトにてメールアドレスの登録から、手続きを行ってください。"
            ]
        }
    },
    applypageheader: "食事券応募申込｜応募申込情報入力",
    quantityfield: {
        legend: "応募申込内容",
        label: "応募申込セット数"
    },
    confirmpageheader: "食事券応募申込｜応募申込情報確認",
    confirmpageexplanation: "応募申込内容をご確認のうえ、応募申込ください。訂正する場合は、下記戻るボタンにて入力画面に戻り訂正してください。",
    applybtn: "次へ",
    acceptbtn: "承諾して応募申込",
    startdatenotice: {
        title: "第2期抽選 Web 受付に関して",
        header: "【愛知県】GoToEat キャンペーン食事券の第2期抽選 Web 受付に関して、以下を確認の上、応募申込を完了してください。",
        alert: "",
        body: "",
        danger: "",
        help: "",
        descriptions: [
            {
                term:"1. 抽選方式について",
                definition: [
                    {text:"Web 受付、はがき受付は同じ当選率で設定します。"}
                ]
            },
            {
                term:"2. 当選通知",
                definition: [
                    {text: "抽選結果は当選者のみメールにて配信されます。（落選の通知は無し）\n配信日：未定 ※決定次第順次配信を開始\n通知方法：メール配信のみ\n※当選通知メールにはファミリーマートにて食事券が発券できる引換票番号が書かれています。\n※当選者の発表は引換票番号通知のメール配信をもってかえさせていただきます。\n※当選者のみ通知がされます。\n※当選結果のメールおよび電話での確認は受け付けておりません。\n※今後新型コロナウイルス感染症拡大状況により、スケジュールは変更になる場合がございます。"},
                ],
            },
            {
                term:"3. 食事券をファミリーマートにて支払・発券",
                definition:[
                    {text: "当選通知に記載されている引換期限までにファミリーマート店舗で引き換えてください。\n"},
                    {text: "支払・発券期間：未定 ※当選通知に記載\n", class: "strong"},
                    {text: "発券場所：全国のファミリーマート店内の Fami ポートにて発券\n※引換開始日は混雑が予想されます。引換期限はゆとりをもたせていますので、慌てずに引換えてください。\n※一部 Fami ポート端末が設置していない店舗もございます。"}
                ]
            }
        ],
        footer: ""
    },
    completemsg: {
        header: "食事券応募申込｜応募申込完了",
        body: {
            paragraphs: [
                {parts:[{text: "応募申込を完了しました。"}]},
                {parts:[{text: "ご登録されたメールアドレスに、応募申込完了通知を送信しました。"}]}
            ]
        },
        mailnotice: {
            header: "メールが届かない場合は以下をご確認ください。",
            items:[
               "迷惑メールボックスやごみ箱フォルダに入っていないかご確認ください。",
               "上記をご確認いただき、申込完了通知が届いていない場合は、「@funity-rs.jp」からメールを受信出来るように設定のうえ、再度受付サイトにてメールアドレスの登録から、手続きを行ってください。"
            ]
        },
        footer: {
            paragraphs: [
                {parts:[
                    {text: "抽選結果は当選者のみメールにて配信されます。（落選の通知は無し）\n"},
                    {text: "配信日：未定 ※決定次第順次配信を開始\n通知方法：メール配信のみ\n", class: "strong"},
                    {text: "※当選通知メールにはファミリーマートにて食事券が発券できる引換票番号が書かれています。\n※当選者の発表は引換票番号通知のメール配信をもってかえさせていただきます。\n"},
                    {text: "※当選者のみ通知がされます。\n※当選結果のメールおよび電話での確認は受け付けておりません。\n", class: "strong"},
                    {text: "※いかなる場合でも、メールの再送はできません。大切に保存ください。\n※今後新型コロナウイルス感染症拡大状況により、スケジュールは変更になる場合がございます。"},
                ]}
            ]
        }
    },
    privacy: "23",
    terms: "23",
    cid: "gaichi",
    unitdetails: "12,500円（1,000円券×10枚　500円券×5枚）／1セット",
    ticketvalue: 12500,
    unitprice: 10000,
    maxunits: 2,
    quantityoptions: [
        {value: "1", text: "1"},
        {value: "2", text: "2"}
    ],
    starttime: "0:00",
    ie11: true,
    ie11Recommendation: true,
    lottery: true,
};
